import React from "react";
import "../projects/questlog.css";
import "../styles/projects.css";
import QuestListItem from "../projects/QuestListItem";

export default function QuestLog({ quests, selectedQuestId, onSelectQuest }) {
  return (
    <div className="quest-boxes quest-log-box">
      <div className="quest-list-title">Quests</div>
      <div className="quest-list-scroll-wrapper">
        <ul className="quest-list">
          {(quests || []).map((quest) => (
            <QuestListItem
              key={quest.id}
              quest={quest}
              isActive={quest.id === selectedQuestId}
              onClick={onSelectQuest}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}
